import {
  takeLatest, call, put, select,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import formatRoomsRequest from '../../../helpers/formatRoomsRequest';
import { updateHotelInAgentTipRequest, updateHotelInAgentTipResponse } from '../../slices/intelligence';
import { getHotelSuccess } from '../../slices/hotel';
import formatHotelDetailRequest from '../../../helpers/formatHotelDetailRequest';

const queryString = require('query-string');

function* updateHotelInAgentTipWorker({
  payload: {
    cruiseItineraryId,
    cruiseDepartureCityId,
    agentTipId,
    checkin,
    checkout,
    hotelId,
    flightOriginGeoIndex,
    searchGeoname,
  },
}) {
  try {
    const staterooms = yield select((state) => state.tripSearch.searchObj.staterooms);
    const { currencyCode } = yield select((store) => store.tripSearch);

    const request = {
      departureCityId: cruiseDepartureCityId,
      checkin,
      checkout,
      ...hotelId,
      ...formatRoomsRequest(staterooms),
      currencyCode: currencyCode || undefined,
    };

    const qs = queryString.stringify({
      ...request,
    }, { skipNull: true });

    const url = `/intelligence/updateHotelInAgentTip?${qs}`;
    const config = {
      method: 'get',
      url,
      params: request,
    };
    const { data } = yield call(axios, config);

    if (data) {
      const response = searchGeoname ? { ...data, searchGeoname } : { ...data };
      yield put(updateHotelInAgentTipResponse({
        cruiseItineraryId,
        flightOriginGeoIndex,
        agentTipId,
        response,
      }));
      const searchKey = queryString.stringify(formatHotelDetailRequest(response, staterooms), {
        skipNull: true,
      });
      yield put(getHotelSuccess({
        itinerary: response,
        response,
        searchKey,
      }));
    } else {
      yield put(updateHotelInAgentTipResponse({
        cruiseItineraryId,
        flightOriginGeoIndex,
        agentTipId,
      }));
    }
  } catch (error) {
    yield put(updateHotelInAgentTipResponse({
      cruiseItineraryId,
      flightOriginGeoIndex,
      agentTipId,
    }));
  }
}

function* updateHotelInAgentTipWatcher() {
  yield takeLatest(updateHotelInAgentTipRequest.toString(), updateHotelInAgentTipWorker);
}

export default updateHotelInAgentTipWatcher;
